import { services } from "../data/content";
import { Reveal } from "./Reveal";
import { SectionHeader } from "./SectionHeader";
import "./Services.css";

export function Services() {
  return (
    <section id="servicos" className="section services">
      <div className="container">
        <SectionHeader
          eyebrow="Serviços"
          title="Onde eu entrego valor"
          description="Quatro frentes que se completam: da interface ao pipeline de dados, passando pelas integrações que ligam tudo."
        />

        <div className="services__grid">
          {services.map((service, i) => (
            <Reveal key={service.index} delay={0.04 * i} amount={0.15}>
              <article className="service">
                <span className="service__index">{service.index}</span>
                <h3 className="h3 service__title">{service.title}</h3>
                <p className="service__desc">{service.description}</p>
                <ul className="tag-row service__tags">
                  {service.items.map((item) => (
                    <li key={item} className="tag">
                      {item}
                    </li>
                  ))}
                </ul>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
